import Bugsnag from '@bugsnag/js';

export const TrackError = e => {
  if (!window.location.href.includes('localhost')) {
    Bugsnag.notify(e);
  }
};
